import React from "react";
import VariantRowDesktop from "./VariantRowDesktop";
import { translate } from "../../Services/translation";
import { Th, Tr } from "./TableSubComponents";

/**
 * @param {array} variants
 * @param tableRef
 * @param colStockRef
 * @param colPriceRef
 * @param colQtyRef
 * @param colAccessoriesRef
 * @param {boolean} showQuantityCol
 * @param {boolean} showAccessoriesCol
 * @param variantAccessoriesOpen
 * @param {boolean} showPrices
 * @param {function} getTableHeaders
 * @param scrollContentRef
 * @param {function} setLightboxImages
 * @returns {JSX.Element}
 * @constructor
 */
const VariantTableDesktop = ({
    variants,
    tableRef,
    colStockRef,
    colPriceRef,
    colQtyRef,
    colAccessoriesRef,
    showQuantityCol,
    showAccessoriesCol,
    variantAccessoriesOpen,
    showPrices,
    getTableHeaders,
    scrollContentRef = null,
    setLightboxImages
}) => {
    return (
        <table className='variant-table__table variant-table__table--desktop' cellSpacing={0} ref={scrollContentRef}>
            <thead>
                <Tr>
                    {getTableHeaders().map(header => (
                        <Th key={header.prop} suffix={header.prop.toLowerCase()}>
                            {header.label}
                        </Th>
                    ))}

                    {showAccessoriesCol && <Th suffix='accessories' refVar={colAccessoriesRef}>{translate('nmas.product.table.header.accessories')}</Th>}
                    <Th suffix='stock' refVar={colStockRef}>{translate('nmas.product.table.header.inventory')}</Th>
                    {showPrices &&
                        <Th suffix='price' refVar={colPriceRef}>{translate('nmas.product.table.header.price')}</Th>}
                    {showQuantityCol && <Th suffix='quantity' refVar={colQtyRef}>
                        {!variants[0].isAnonymousUser ?
                            translate('nmas.product.table.header.quantity') :
                            translate('nmas.product.table.header.login')}
                    </Th>}
                </Tr>
            </thead>

            <tbody>
                {variants.map(variant => (
                    <VariantRowDesktop {...{
                        variant,
                        tableRef,
                        showQuantityCol,
                        showAccessoriesCol,
                        showPrices,
                        variantAccessoriesOpen,
                        setLightboxImages,
                        tableHeaders: getTableHeaders(true)
                    }} key={variant.id} />
                ))}
            </tbody>
        </table>
    );
}


export default VariantTableDesktop;